import angular from 'angular';

import { cut, reflect, truncateName } from '../filters';

const module = 'app.filters';
const requires = [];

angular.module(module, requires);
angular.module(module).registerComponents(
  {
    cut,
    reflect,
    truncateName,
  },
  'filter'
);
